<!-- Nav visible -->
@if ((pageLoading$ | async) === false) {
  @if ((navItems$ | async) && (isOnboardingUrl$ | async) === false) {
    <atlas-navbar
      [dropdownItems]="menuItems"
      [hideBottomBorder]="useDarkNavHeader$ | async"
      [enableDarkModeToggle]="pccDarkModeFeatureFlag$ | async"
      [darkModeToggleContext]="'partner-center-client'"
    >
      <div class="atlas-navbar-space">
        <atlas-item>
          <button mat-icon-button (click)="nav.toggle()">
            <mat-icon>menu</mat-icon>
          </button>
        </atlas-item>
        <div class="atlas-title">
          <atlas-title
            icon="location_city"
            interactable="{{ showAtlasPidSelector$ | async }}"
            (click)="showAtlasPidSelector()"
          >
            {{ atlasTitle$ | async }}
          </atlas-title>
        </div>
        <div class="atlas-spacer"></div>
        <div class="atlas-actions">
          @if (isMobile$ | async) {
            <atlas-item icon="arrow_drop_down" interactable [matTooltip]="'Others'">
              <atlas-menu>
                @if ((inboxAIFeatureFlag$ | async) && (hasViewAccessForInboxAI$ | async)) {
                  <inbox-ai-button [isMobile]="true"></inbox-ai-button>
                }
              </atlas-menu>
            </atlas-item>
            <atlas-item
              interactable
              icon="help"
              [matTooltip]="'NAVIGATION.HELP' | translate"
              [customClass]="helpDrawerSelected$ | async"
              (click)="showHelpCenter(helpCenterTemplateId)"
            ></atlas-item>
            @if ((hasViewAccessForInboxFeature$ | async) && (fullscreenInboxViewFeatureFlag$ | async) === false) {
              <inbox-button (click)="showHelpCenter()"></inbox-button>
            }
          } @else {
            @if (hasViewAccessForNewReleases$ | async) {
              <atlas-item
                data-canny-changelog
                interactable
                icon="new_releases"
                [matTooltip]="'NAVIGATION.NEW_RELEASES' | translate"
              ></atlas-item>
            }
            @if (hasViewAccessForHelpCenter$ | async) {
              <atlas-item
                interactable
                icon="help"
                [matTooltip]="'NAVIGATION.HELP' | translate"
                [customClass]="helpDrawerSelected$ | async"
                (click)="showHelpCenter(helpCenterTemplateId)"
              ></atlas-item>
            }
            <div>
              @if (hasSalesCoach$ | async) {
                <atlas-item
                  interactable
                  icon="emergency_recording"
                  [matTooltip]="'NAVIGATION.JOIN_MEETING_V2' | translate"
                >
                </atlas-item>
              }
              <atlas-menu id="atlas-navbar__meetings-join">
                <meeting-analysis-schedule-bot></meeting-analysis-schedule-bot>
              </atlas-menu>
            </div>
            <!-- FIXME: Clicking on the inbox AI button raises a component metadata error in the console logs -->
            @if ((inboxAIFeatureFlag$ | async) && (hasViewAccessForInboxAI$ | async)) {
              <inbox-ai-button [isMobile]="false" (click)="showHelpCenter()"></inbox-ai-button>
            }
            @if ((hasViewAccessForInboxFeature$ | async) && (fullscreenInboxViewFeatureFlag$ | async) === false) {
              <inbox-button (click)="showHelpCenter()"></inbox-button>
            }
          }
          <ng-template #desktop>
            @if (hasViewAccessForNewReleases$ | async) {
              <atlas-item
                data-canny-changelog
                interactable
                icon="new_releases"
                [matTooltip]="'NAVIGATION.NEW_RELEASES' | translate"
              ></atlas-item>
            }
            @if (hasViewAccessForHelpCenter$ | async) {
              <atlas-item
                interactable
                icon="help"
                [matTooltip]="'NAVIGATION.HELP' | translate"
                [customClass]="helpDrawerSelected$ | async"
                (click)="showHelpCenter(helpCenterTemplateId)"
              ></atlas-item>
            }
            <div>
              @if (hasSalesCoach$ | async) {
                <atlas-item
                  interactable
                  icon="emergency_recording"
                  [matTooltip]="'NAVIGATION.JOIN_MEETING_V2' | translate"
                >
                </atlas-item>
              }
              <atlas-menu id="atlas-navbar__meetings-join">
                <meeting-analysis-schedule-bot></meeting-analysis-schedule-bot>
              </atlas-menu>
            </div>
            @if ((inboxAIFeatureFlag$ | async) && (hasViewAccessForInboxAI$ | async)) {
              <inbox-ai-button [isMobile]="false" (click)="showHelpCenter()"></inbox-ai-button>
            }
            @if ((hasViewAccessForInboxFeature$ | async) && (fullscreenInboxViewFeatureFlag$ | async) === false) {
              <inbox-button (click)="showHelpCenter()"></inbox-button>
            }
          </ng-template>
        </div>
      </div>
    </atlas-navbar>
    <inbox-inbox modeType="over" [disabled]="disableInboxFeature$ | async">
      <glxy-nav #nav [appName]="'partner-center'" [ngClass]="vaNavTheme$ | async">
        <glxy-nav-panel [multi]="false">
          <glxy-nav-header [ngClass]="{ 'dark-header': (useDarkNavHeader$ | async) }">
            <app-logo></app-logo>
            <div>
              @if ((isSuperAdminRoute$ | async) === false) {
                <app-level-badge></app-level-badge>
              }
            </div>
            @if ((isSuperAdminRoute$ | async) === false) {
              <app-trial-badge class="trial-badge"></app-trial-badge>
            }
          </glxy-nav-header>
          <!-- PCC nav items are set in the partner microservice -->
          <!-- You can modify them here: https://github.com/vendasta/partner/blob/master/internal/partner_center_navigation/service.go -->
          @for (menuItem of navItems$ | async; track menuItem) {
            <app-nav-item [activeMenuId]="activeMenuId$ | async" [item]="menuItem"></app-nav-item>
          }
          <glxy-nav-footer>
            @if (showFooterActions$ | async) {
              <div class="footer-actions">
                @if (hasViewAccessForSalesContactCard$ | async) {
                  <app-assigned-salesperson-nav-footer-card></app-assigned-salesperson-nav-footer-card>
                }
                @if (exitToBusinessCenterUrl$ | async; as exitUrl) {
                  <div class="exit-admin">
                    <a mat-button [href]="exitUrl">
                      <mat-icon>swap_calls</mat-icon>
                      {{ 'NAVIGATION.EXIT_ADMIN' | translate }}
                    </a>
                  </div>
                }
              </div>
            }
          </glxy-nav-footer>
        </glxy-nav-panel>
        <!-- Page Content -->
        <app-help-side-drawer-container [modeType]="viewMode$ | async">
          <ng-container *ngTemplateOutlet="pageContent"></ng-container>
          <router-outlet name="action"></router-outlet>
        </app-help-side-drawer-container>
      </glxy-nav>
    </inbox-inbox>
  } @else {
    <router-outlet>
      @if (loadingLazyModule) {
        <glxy-loading-spinner [fullHeight]="true"></glxy-loading-spinner>
      }
    </router-outlet>
  }
} @else {
  <div id="loading-spinner">
    <mat-spinner [diameter]="50"></mat-spinner>
  </div>
}

<ng-template #loading>
  <div id="loading-spinner">
    <mat-spinner [diameter]="50"></mat-spinner>
  </div>
</ng-template>

<ng-template #pageContent>
  <router-outlet>
    @if (loadingLazyModule) {
      <glxy-loading-spinner [fullHeight]="true"></glxy-loading-spinner>
    }
  </router-outlet>
</ng-template>

<ng-template #helpCenter>
  <app-help-center [partnerId]="partnerId" [subscriptionTier]="subscriptionTier"></app-help-center>
</ng-template>
